import { Metrics } from '@moonpig/web-core-monitoring'
import { NextPageContext } from 'next/types'
import { handleNormaliseRedirects } from './handleNormalisedRedirects'
import { handleLegacyRedirects } from './handleLegacyRedirects'

export type ServerRedirectResponse = {
  source: string
  destination: string
  permanent: boolean
}

export type ServerRedirect = (
  asPath: string,
) => Promise<null | ServerRedirectResponse>

export const handleRedirects = async (
  customAsPath: string,
  res: NextPageContext['res'],
  metrics: Metrics,
) => {
  const redirectNormalised = handleNormaliseRedirects(customAsPath, res)
  if (redirectNormalised) {
    return redirectNormalised
  }

  const redirectResult = await handleLegacyRedirects(customAsPath, res, metrics)
  if (redirectResult) {
    return redirectResult
  }
}
